import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    // data: [],
};

const instantRebateReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.value,
    }),

    [type.CALCULATE]: (state, action) => ({
            ...state,
            total_instant_rebate_data: action.payload,
    }),

    [type.CLAIM_SUCCESS]: (state, action) => ({
        ...state,
        claim_result: action.value,
    }),

    [type.CLAIM_FAIL]: (state, action) => ({
        ...state,
        claim_result: { error: true, data: action.value },
    }),

    [type.HISTORY]: (state, action) => ({
        ...state,
        history: action.value,
    }),
   
    [type.HISTORY_BY_TRANSACTION]: (state, action) => ({
      ...state,
      historyByTransaction: action.value,
    }),
});

export default instantRebateReducer;